var BASWebServices;
(function (BASWebServices) {
    var BrowserTypeService = (function () {
        function BrowserTypeService($window) {
            this.$window = $window;
        }
        BrowserTypeService.Factory = function ($window) {
            return new BrowserTypeService($window);
        };
        BrowserTypeService.prototype.getBrowserType = function () {
            var userAgent = this.$window.navigator.userAgent;
            var browsers = { chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i };
            for (var key in browsers) {
                if (browsers[key].test(userAgent)) {
                    return key;
                }
            }
            ;
            return 'unknown';
        };
        return BrowserTypeService;
    }());
    BASWebServices.BrowserTypeService = BrowserTypeService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=BrowserTypeService.js.map